// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"359":"97a15f0f","361":"a7aeca64","511":"5b3e8ac6","767":"42a493c6"}[chunkId] + ".chunk.js";
};